"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimplifiedRegistrationContent = void 0;
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = require("react");
var _Localization = require("./Localization");
var _components = require("./components");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("./constants/defaultTranslations_simplified-registration-BrandPartner");
var _containers = require("./containers");
var _contexts = require("./contexts");
var _TranslationKey_simplifiedRegistrationBrandPartner = require("./models/TranslationKey_simplified-registration-BrandPartner");
var _pages = require("./pages");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const StyledImg = (0, _mui.styled)('img')(({
  theme
}) => ({
  height: '100%',
  objectFit: 'cover',
  objectPosition: '50% 50%'
}));
const Footer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '75px',
  width: '100%',
  backgroundColor: theme.palette.grey[100],
  zIndex: 1,
  lineHeight: '75px',
  overflow: 'hidden',
  textAlign: 'center'
}));
const JoinUsContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  position: 'relative',
  WebkitBoxDirection: 'normal',
  WebkitBoxOrient: 'vertical',
  flexDirection: 'column',
  minHeight: '100vh'
}));
const JoinUsMain = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  position: 'relative',
  WebkitBoxDirection: 'normal',
  flex: 1,
  WebkitBoxOrient: 'horizontal',
  flexDirection: 'row'
}));
const JoinUsApp = (0, _mui.styled)('div')(({
  theme
}) => ({
  width: '50%',
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}));
const JoinUsAppWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  margin: 'min(100px, 8vh) auto auto',
  paddingBottom: '50px',
  [theme.breakpoints.down('sm')]: {
    marginTop: 0
  }
}));
const JoinUsImg = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  overflow: 'hidden',
  width: '50%',
  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}));
const SimplifiedRegistrationContent = ({
  contentWithImage
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const pbs_owner = _jsCookie.default.get('pbs_owner') ?? '';
  const registrationId = (0, _utils.getStringQueryParameter)('registrationId');
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const [showLeavingDialog, setShowLeavingDialog] = (0, _react.useState)(false);
  const isVipRegistrationType = ['member-benefits', 'vip-customer-benefits', 'self-vip-registration'].some(substring => path.includes(substring));
  const {
    data: referral
  } = (0, _staticApiClientReact.useGetTenantApplicationsShareAndEarnPersonalCodeCustomer)(tenant, pbs_owner, {}, {
    swr: {
      revalidateOnFocus: false
    }
  });
  const {
    data: configuration
  } = (0, _globalApiClientReact.useGetApplicationsSimplifiedRegistrationBrandPartnerConfiguration)({
    registrationId
  }, {}, {
    swr: {
      revalidateOnFocus: false,
      enabled: !isVipRegistrationType
    }
  });
  const {
    data: configurationVip
  } = (0, _globalApiClientReact.useGetApplicationsSimplifiedRegistrationVipCustomerConfiguration)({
    registrationId
  }, {}, {
    swr: {
      revalidateOnFocus: false,
      enabled: isVipRegistrationType
    }
  });
  const correctConfiguration = isVipRegistrationType ? configurationVip : configuration;
  const handleLeaveSite = () => {
    if (typeof window !== 'undefined') {
      window.location.href = correctConfiguration?.supportCenterUrl ?? '/';
    }
  };
  if (!correctConfiguration?.isEnabled) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.ConfigurationProvider, {
    value: {
      currentLanguage: language,
      ...correctConfiguration,
      referral,
      registrationId: registrationId ?? ''
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.ContentsContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.ClientCultureProvider, {
        tenant: tenant,
        language: language,
        options: {
          swr: {
            suspense: true
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("main", {
          children: [contentWithImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(JoinUsContainer, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(JoinUsMain, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(JoinUsApp, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(JoinUsAppWrapper, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_pages.LandingPage, {})
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(JoinUsImg, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
                  sx: {
                    height: '100%',
                    overflow: 'hidden',
                    position: 'fixed',
                    top: 0,
                    width: '50vw'
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledImg, {
                    src: correctConfiguration.rightImageUrl,
                    alt: "simplified registration image"
                  })
                })
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Footer, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
                component: "button",
                onClick: () => setShowLeavingDialog(true),
                sx: {
                  textTransform: 'uppercase',
                  color: _mui.theme.palette.grey[700],
                  textDecoration: 'none',
                  fontWeight: 700,
                  fontSize: '12px'
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
                  id: _TranslationKey_simplifiedRegistrationBrandPartner.TranslationKey.SupportCenter,
                  defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SupportCenter
                })
              })
            })]
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_pages.LandingPage, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ConfirmLeavingDialog, {
            opened: showLeavingDialog,
            handleCancel: () => setShowLeavingDialog(false),
            handleConfirm: () => handleLeaveSite()
          })]
        })
      })
    })
  });
};
exports.SimplifiedRegistrationContent = SimplifiedRegistrationContent;